import styled from '@emotion/styled';
import { Placement } from '@popperjs/core';
import { IStyledDropdownProps, IStyledPopperProps } from './Types';

export function getBorderRadius(
  interestPlacement: Placement,
): (props: IStyledDropdownProps) => number {
  return ({ expanded, placement }) => {
    if (expanded) {
      if (placement === interestPlacement) return 0;
      return 1.6;
    }
    return 3.125;
  };
}

export function getBorderWidth(
  interestPlacement: Placement,
): (props: IStyledDropdownProps) => number {
  return ({ expanded, placement }) => {
    if (expanded) {
      if (placement === interestPlacement) {
        return 1;
      }
      return 0;
    }
    return 1;
  };
}

export const DropdownButton = styled.button<IStyledDropdownProps>`
  height: 3.123rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  color: #7d7d7d;
  border-top-left-radius: ${getBorderRadius('top-start')}rem;
  border-top-right-radius: ${getBorderRadius('top-start')}rem;
  border-bottom-left-radius: ${getBorderRadius('bottom-start')}rem;
  border-bottom-right-radius: ${getBorderRadius('bottom-start')}rem;
  transition: all 0.2s ${({ expanded }) => (expanded ? 0 : '0.1s')};
  border: 1px solid #aeadad;
  border-bottom-width: ${getBorderWidth('top-start')}px;
  border-top-width: ${getBorderWidth('bottom-start')}px;
  font-size: 0.875rem;
  &:focus {
    outline: none;
  }
  @media screen and (min-width: 640px) {
    font-size: 1rem;
  }
`;

export const Popper = styled.div<IStyledPopperProps>`
  width: ${({ $width }) => ($width ? `${$width}px` : 'auto')};
  opacity: ${({ expanded }) => (expanded ? 1 : 0)};
  transition: ${({ shouldAnimate }) => shouldAnimate && 'all 0.2s'};
  height: ${({ expanded, $height, animation }) =>
    animation === 'fade' || expanded ? $height : 0}px;
  overflow-y: ${({ expanded }) => (expanded ? 'scroll' : 'hidden')};
  transform: translate(
    ${({ xOffset }) => xOffset}px,
    ${({ yOffset }) => yOffset}px
  );
  overflow-x: hidden;
  z-index: ${({ expanded }) => (expanded ? 10 : -1)};
`;

export const SVG = styled.svg``;
